/**
 * GET `admin/notifications/telemetry` — доставляемость пушей по платформам
 * за N дней: отправлено, ошибки, показано. displayRate ниже ~0.5 — повод
 * разбираться (агрессивная прошивка, протухшие токены).
 */

import {apiEnabled, http} from '@services/utils';

import {mockTelemetry} from '../mocks';
import {asNum, asObj, toTelemetryRow} from '../toSystem';
import type {Telemetry} from '../types';

const sleep = (ms: number) => new Promise((r) => setTimeout(r, ms));

export const getTelemetry = async (days: number): Promise<Telemetry> => {
  if (!apiEnabled) {
    await sleep(200);
    return mockTelemetry(days);
  }
  const r = asObj(
    await http('admin/notifications/telemetry', {params: {days}, skipCaseConversion: true}),
  );
  return {
    days: asNum(r.days) || days,
    rows: (Array.isArray(r.rows) ? r.rows : []).map(toTelemetryRow),
    totalSent: asNum(r.totalSent),
    totalFailed: asNum(r.totalFailed),
    totalDisplayed: asNum(r.totalDisplayed),
  };
};
